export enum VacancyStatusesT {
    'CREATED' = 'created',
    'PUBLISHED' = 'published',
    'ARCHIVE' = 'archive',
}

export enum FeedbackStatusesT {
    'CREATED' = 'created',
    'VIEWED' = 'viewed',
    'BETHINKED' = 'bethinked',
    'CANCELED' = 'canceled',
    'ARCHIVE' = 'archive',
}
